import React, { useState } from 'react';
import TreeItem from '../TreeItem';
import { DatSetResultType } from '../_type';
const findMinValue = (arr: number[] = []) => {
  const min = Math.min(...arr);
  return min;
};
export default function DatSetResult(props: DatSetResultType) {
  const { dataSetData, getFilrstSelecteTable } = props;
  const [selectedItems, setSelectedItems] = useState<number[]>([]);
  const getSelected = (selectedArr: number[]) => {
    const firstIndex = findMinValue(selectedArr);
    return dataSetData?.[firstIndex];
  };

  const setSelectedItemsFunc = (arr: number[]) => {
    const selectedItem = getSelected(arr);
    setSelectedItems(arr);
    getFilrstSelecteTable(selectedItem);
  };

  return (
    <div className='dbl-drag-add-sourse-dataset-result'>
      {(dataSetData || []).map((item: any, index) => (
        <div key={index}>
          <TreeItem
            {...props}
            treeIndex={index}
            setSelectedItems={(val) => setSelectedItemsFunc(val)}
            selectedItems={selectedItems}
            tableInfo={item}
          />
        </div>

      ))}
    </div>
  );
}
